import { render, staticRenderFns } from "./pin-show.vue?vue&type=template&id=ecb05eaa&"
import script from "./pin-show.vue?vue&type=script&lang=js&"
export * from "./pin-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports